import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';

import { is } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ImmutablePureComponent from 'react-immutable-pure-component';

import Textarea from 'react-textarea-autosize';

const messages = defineMessages({
  placeholder: { id: 'account_note.placeholder', defaultMessage: 'Click to add a note' },
});

class InlineAlert extends PureComponent {

  static propTypes = {
    show: PropTypes.bool,
  };

  state = {
    mountMessage: false,
  };

  static TRANSITION_DELAY = 200;

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (!this.props.show && nextProps.show) {
      this.setState({ mountMessage: true });
    } else if (this.props.show && !nextProps.show) {
      setTimeout(() => this.setState({ mountMessage: false }), InlineAlert.TRANSITION_DELAY);
    }
  }

  render () {
    const { show } = this.props;
    const { mountMessage } = this.state;

    return (
      <span aria-live='polite' role='status' className='inline-alert' style={{ opacity: show ? 1 : 0 }}>
        {mountMessage && <FormattedMessage id='generic.saved' defaultMessage='Saved' />}
      </span>
    );
  }

}

class AccountNote extends ImmutablePureComponent {

  static propTypes = {
    account: ImmutablePropTypes.record.isRequired,
    value: PropTypes.string,
    onSave: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
  };

  state = {
    value: '',
    saving: false,
    saved: false,
  };

  UNSAFE_componentWillMount () {
    this._reset();
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    const accountWillChange = !is(this.props.account, nextProps.account);
    const newState = {};

    if (accountWillChange && this._isDirty()) {
      this._save(false);
    }

    if (accountWillChange || nextProps.value === this.state.value) {
      newState.saving = false;
    }

    if (this.props.value !== nextProps.value) {
      newState.value = nextProps.value || '';
    }

    this.setState(newState);
  }

  componentWillUnmount () {
    if (this._isDirty()) {
      this._save(false);
    }
  }

  setTextareaRef = c => {
    this.textarea = c;
  };

  handleChange = e => {
    this.setState({ value: e.target.value, saving: false });
  };

  handleKeyDown = e => {
    if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();

      this._save();

      if (this.textarea) {
        this.textarea.blur();
      }
    } else if (e.keyCode === 27) {
      e.preventDefault();

      this._reset(() => {
        if (this.textarea) {
          this.textarea.blur();
        }
      });
    }
  };

  handleBlur = () => {
    if (this._isDirty()) {
      this._save();
    }
  };

  _save (showMessage = true) {
    this.setState({ saving: true }, () => this.props.onSave(this.state.value));

    if (showMessage) {
      this.setState({ saved: true }, () => setTimeout(() => this.setState({ saved: false }), 2000));
    }
  }

  _reset (callback) {
    this.setState({ value: this.props.value || '' }, callback);
  }

  _isDirty () {
    return (
      !this.state.saving &&
      this.state.value !== this.props.value
    );
  }

  render () {
    const { account, intl } = this.props;
    const { value } = this.state;

    if (!account) {
      return null;
    }

    const EditNoteIcon = () => {
      return (
        <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M1.33325 11.2502H10.6666M2.30509 6.69261C2.05636 6.94189 1.91665 7.27964 1.91659 7.63178V9.5002H3.79667C4.149 9.5002 4.48675 9.3602 4.73584 9.11053L10.2775 3.56595C10.5261 3.31663 10.6658 2.97889 10.6658 2.62678C10.6658 2.27467 10.5261 1.93693 10.2775 1.68761L9.73034 1.13928C9.60694 1.01582 9.46042 0.91789 9.29914 0.851094C9.13787 0.784299 8.96502 0.749946 8.79046 0.75C8.61591 0.750054 8.44308 0.784514 8.28185 0.85141C8.12062 0.918305 7.97416 1.01632 7.85084 1.13986L2.30509 6.69261Z' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      );
    };

    return (
      <div className='account__header__account-note'>
        <div className='textarea-wrapper'>
          <Textarea
            id={`account-note-${account.get('id')}`}
            className='account__header__account-note__content'
            disabled={this.props.value === null || value === null}
            placeholder={intl.formatMessage(messages.placeholder)}
            value={value || ''}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            onBlur={this.handleBlur}
            ref={this.setTextareaRef}
          />
          <button
            type='button'
            className='edit-button'
            onClick={() => {
              if (this.textarea) {
                this.textarea.focus();
              }
            }}
            aria-label='Edit note'
          >
            <EditNoteIcon />
          </button>
        </div>
      </div>
    );
  }

}

export default injectIntl(AccountNote);
